<template>
  <div>
    <div class="das_top_cont">
      <div class="Data_Management_box margin-bottom10">
        <!-- <h2 class="history_box-head flex_center_between_box">
                        Data Management
                    </h2> -->
        <div class="flex_center_between_box" style="margin-bottom: 0px">
          <div style="display: flex" class="font_size_12">
            <div class="sel_box computer_right_cont_box">
              <el-date-picker
                v-model="CategoryYear"
                :disabled="datePicker?.length > 0"
                style="width: fit-content; max-width: 310px"
                value-format="yyyy"
                type="year"
                :placeholder="$t('DataManagement.SelectYear')"
                @change="(val) => onChangeParams(val, 'year')"
              >
              </el-date-picker>
            </div>
            <div class="sel_box computer_right_cont_box">
              <el-select
                clearable
                v-model="Quarter"
                :disabled="
                  CategoryYear == null || CategoryYear == '' || Month != ''
                "
                style="max-width: 310px; height: 100%"
                filterable
                class="search-select-con"
                :popper-append-to-body="true"
                popper-class="new-search-select"
                :placeholder="$t('DataManagement.SelectQuarter')"
                @change="(val) => onChangeParams(val, 'Quarter')"
              >
                <el-option
                  v-for="(item, index) in QuarterList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                  <div class="flex-between-center">
                    <span class="select-name">{{ item.label }}</span>
                  </div>
                </el-option>
              </el-select>
            </div>
            <div class="sel_box computer_right_cont_box">
              <el-select
                clearable
                v-model="Month"
                :disabled="
                  CategoryYear == null || CategoryYear == '' || Quarter != ''
                "
                style="max-width: 310px; height: 100%"
                filterable
                class="search-select-con"
                :popper-append-to-body="true"
                popper-class="new-search-select"
                :placeholder="$t('DataManagement.SelectMonth')"
                @change="(val) => onChangeParams(val, 'Month')"
              >
                <el-option
                  v-for="(item, index) in MonthList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                  <div class="flex-between-center">
                    <span class="select-name">{{ item.label }}</span>
                  </div>
                </el-option>
              </el-select>
            </div>
            <div class="sel_box computer_right_cont_box">
              <el-date-picker
                v-model="datePicker"
                @change="(val) => onChangeParams(val, 'datePicker')"
                :disabled="CategoryYear != '' && CategoryYear != null"
                style="width: fit-content; max-width: 350px"
                type="daterange"
                range-separator=""
                :start-placeholder="$t('DataManagement.StartingMonth')"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('DataManagement.EndMonth')"
              ></el-date-picker>
            </div>
          </div>
          <div class="flex_center">
            <button
              class="btn_blue flex_center  "
              @click="ResetChange()"
            >
              {{ $t("DataManagement.Reset") }}  
            </button>

            <button
              class="btn_blue flex_center margin-left10"
              @click="getUserCompanyActionCountryMapList()"
            >
              {{ $t("DataManagement.Search") }}  
            </button>
          </div>
        </div>
      </div>
      <div class="accountright_cont_box margin-bottom10">
        <h2 class="history_box-head flex_center_between_box">{{ $t("DataManagement.MyDatabase") }}</h2>
        <div class="flex_center_between_box" style="margin-bottom: 0px">
          <ul class="flex_center_bettwen" style="width: 100%">
            <li class="Database-Cared">
              <p class="font26 font1290C9 font_bold text_center">
                {{ allDataObject.allData }}
              </p>
              <p class="font18 font1A2332 text_center">{{ $t("DataManagement.AllData") }}</p>
            </li>
            <li class="Database-Cared">
              <p class="font26 font1290C9 font_bold text_center">
                {{ allDataObject.companiesViewed }}
              </p>
              <p class="font18 font1A2332 text_center">{{ $t("DataManagement.CompaniesViewed") }}</p>
            </li>
            <li class="Database-Cared">
              <p class="font26 font1290C9 font_bold text_center">
                {{ allDataObject.companiesCollected }}
              </p>
              <p class="font18 font1A2332 text_center">{{ $t("DataManagement.CompaniesCollected") }}</p>
            </li>
            <li class="Database-Cared">
              <p class="font26 font1290C9 font_bold text_center">
                {{ allDataObject.companiesUploaded }}
              </p>
              <p class="font18 font1A2332 text_center">{{ $t("DataManagement.CompaniesUploaded") }}</p>
            </li>
            <li class="Database-Cared">
              <p class="font26 font1290C9 font_bold text_center">
                {{ allDataObject.myPortfolio }}
              </p>
              <p class="font18 font1A2332 text_center">{{ $t("DataManagement.MyPortfolio") }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="accountright_cont_box margin-bottom10">
        <h2 class="history_box-head flex_center_between_box">
          {{ $t("DataManagement.CompanyType") }}
          <svg
            t="1763711828255"
            class="icon icon-size"
            v-if="CompanyTypeShow == 'Table'"
            @click="
              CompanyTypeShow = 'Echarts';
              setEchartsAll();
            "
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="8053" 
          >
            <path
              d="M307.237248 42.521441A46.540625 46.540625 0 1 1 344.446708 127.87152C171.941755 203.160838 70.822134 384.331359 97.279635 570.74986c26.444701 186.418501 173.951348 332.286754 360.625848 356.606662 186.6617 24.319909 366.616225-78.873304 439.93435-252.287054a46.540625 46.540625 0 1 1 85.721279 36.262265c-89.599664 211.954405-309.541239 338.085132-537.687584 308.350843C217.727184 989.948288 37.42706 811.683356 5.119981 583.844211c-32.319879-227.839146 91.263658-449.278315 302.130067-541.309971zM512.02368 0a511.90848 511.90848 0 0 1 362.021042 149.989838A512.151679 512.151679 0 0 1 1023.99616 512.10048a46.553425 46.553425 0 0 1-46.540625 46.553425H512.02368a46.553425 46.553425 0 0 1-46.540626-46.553425V46.566225A46.553425 46.553425 0 0 1 512.02368 0z m46.540625 95.705241V465.534254h369.752214a419.032029 419.032029 0 0 0-120.10195-249.727063 418.852829 418.852829 0 0 0-249.650264-120.11475z"
              fill="#1290C9"
              p-id="8054"
            ></path>
          </svg>
          <svg
            t="1763780588104"
            class="icon icon-size"
            v-if="CompanyTypeShow == 'Echarts'"
            @click="CompanyTypeShow = 'Table'"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="7846" 
          >
            <path
              d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
              fill="#1A2332"
              p-id="7847"
            ></path>
          </svg>
        </h2>
        <div
          class="flex_center_between_box"
          v-if="CompanyTypeShow == 'Table'"
          style="margin-bottom: 0px"
        >
          <ul
            class="flex_center_bettwen"
            style="width: 100%; flex-wrap: wrap; "
          >
            <li
              class="  Database-Cared-Two"
              v-for="(item, index) in companyTypeList"
              :key="index"
            >
              <p class="font26 font1290C9 font_bold">{{ item.cnt }}</p>
              <p class="font18 font1A2332 flex_center text-center">
                {{ item.groupNameEn }}
              </p>
            </li>
          </ul>
        </div>
        <div
          class="Products_lesft"
          v-show="CompanyTypeShow == 'Echarts'"
          style="height: auto"
        >
          <div
            ref="SupplyChainEchart"
            style="width: 98%; height: 100%; min-height: 35rem"
          ></div>
        </div>
      </div>
      <!-- Country -->
      <div class="accountright_cont_box margin-bottom10" style="width: 100%">
        <h2 class="history_box-head flex_center_between_box">
          {{ $t("DataManagement.CountriesLocated") }}
          <svg
            t="1763711828255"
            class="icon icon-size"
            v-if="CountryShow == 'Table'"
            @click="
              CountryShow = 'Echarts';
              setEchartsAll();
            "
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="8053" 
          >
            <path
              d="M307.237248 42.521441A46.540625 46.540625 0 1 1 344.446708 127.87152C171.941755 203.160838 70.822134 384.331359 97.279635 570.74986c26.444701 186.418501 173.951348 332.286754 360.625848 356.606662 186.6617 24.319909 366.616225-78.873304 439.93435-252.287054a46.540625 46.540625 0 1 1 85.721279 36.262265c-89.599664 211.954405-309.541239 338.085132-537.687584 308.350843C217.727184 989.948288 37.42706 811.683356 5.119981 583.844211c-32.319879-227.839146 91.263658-449.278315 302.130067-541.309971zM512.02368 0a511.90848 511.90848 0 0 1 362.021042 149.989838A512.151679 512.151679 0 0 1 1023.99616 512.10048a46.553425 46.553425 0 0 1-46.540625 46.553425H512.02368a46.553425 46.553425 0 0 1-46.540626-46.553425V46.566225A46.553425 46.553425 0 0 1 512.02368 0z m46.540625 95.705241V465.534254h369.752214a419.032029 419.032029 0 0 0-120.10195-249.727063 418.852829 418.852829 0 0 0-249.650264-120.11475z"
              fill="#1290C9"
              p-id="8054"
            ></path>
          </svg>
          <svg
            t="1763780588104"
            class="icon icon-size"
            v-if="CountryShow == 'Echarts'"
            @click="
              CountryShow = 'Table';
              setEchartsAll();
            "
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="7846" 
          >
            <path
              d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
              fill="#1A2332"
              p-id="7847"
            ></path>
          </svg>
        </h2>
        <div
          class="Products_lesft"
          v-show="CountryShow == 'Table'"
          style="height: auto"
        >
          <div
            ref="SupplyChainEchart4"
            style="width: 100%; height: 100%; min-height: 35rem"
          ></div>
        </div>
        <div
          class="Products_lesft"
          v-show="CountryShow == 'Echarts'"
          style="height: auto"
        >
          <div
            ref="SupplyChainEchart5"
            style="width: 98%; height: 100%; min-height: 35rem"
          ></div>
        </div>
      </div>

      <div class="accountright_cont_box margin-bottom10" style="width: 100%">
        <h2 class="history_box-head flex_center_between_box">
          {{ $t("DataManagement.YearsinBusiness") }}
          <svg
            t="1763711828255"
            class="icon icon-size"
            v-if="YearsinBusinessShow == 'Table'"
            @click="
              YearsinBusinessShow = 'Echarts';
              setEchartsAll();
            "
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="8053" 
          >
            <path
              d="M307.237248 42.521441A46.540625 46.540625 0 1 1 344.446708 127.87152C171.941755 203.160838 70.822134 384.331359 97.279635 570.74986c26.444701 186.418501 173.951348 332.286754 360.625848 356.606662 186.6617 24.319909 366.616225-78.873304 439.93435-252.287054a46.540625 46.540625 0 1 1 85.721279 36.262265c-89.599664 211.954405-309.541239 338.085132-537.687584 308.350843C217.727184 989.948288 37.42706 811.683356 5.119981 583.844211c-32.319879-227.839146 91.263658-449.278315 302.130067-541.309971zM512.02368 0a511.90848 511.90848 0 0 1 362.021042 149.989838A512.151679 512.151679 0 0 1 1023.99616 512.10048a46.553425 46.553425 0 0 1-46.540625 46.553425H512.02368a46.553425 46.553425 0 0 1-46.540626-46.553425V46.566225A46.553425 46.553425 0 0 1 512.02368 0z m46.540625 95.705241V465.534254h369.752214a419.032029 419.032029 0 0 0-120.10195-249.727063 418.852829 418.852829 0 0 0-249.650264-120.11475z"
              fill="#1290C9"
              p-id="8054"
            ></path>
          </svg>
          <svg
            t="1763780588104"
            class="icon icon-size"
            v-if="YearsinBusinessShow == 'Echarts'"
            @click="YearsinBusinessShow = 'Table'"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="7846" 
          >
            <path
              d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
              fill="#1A2332"
              p-id="7847"
            ></path>
          </svg>
        </h2>
        <div
          class="flex_center_between_box"
          v-show="YearsinBusinessShow == 'Table'"
          style="margin-bottom: 0px"
        >
          <ul
            class="flex_center_bettwen Database-Cared-Business-Bg"
            style="width: 100%; "
          >
            <li
              class="Database-Cared Database-Cared-Business"
              v-for="(item, index) in yearsInBusinessList"
              :key="index"
            >
              <p class="font26 font1290C9 font_bold">{{ item.cnt }}</p>
              <p class="font18 font1A2332 flex_center">
                {{ item.groupNameEn }}
              </p>
            </li>
          </ul>
        </div>
        <div
          class="Products_lesft"
          v-show="YearsinBusinessShow == 'Echarts'"
          style="height: auto"
        >
          <div
            ref="SupplyChainEchart1"
            style="width: 98%; height: 100%; min-height: 35rem"
          ></div>
        </div>
      </div>
      <div class="flex_center_bettwen">
        <div
          class="accountright_cont_box margin-bottom10"
          :style="CompanySizeShow == 'Table' ? 'width:40%;' : 'width:100%;'"
        >
          <h2 class="history_box-head flex_center_between_box">
            {{ $t("DataManagement.CompanySize") }}
            <svg
              t="1763711828255"
            class="icon icon-size"
              v-if="CompanySizeShow == 'Table'"
              @click="
                CompanySizeShow = 'Echarts';
                setEchartsAll();
              "
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="8053" 
            >
              <path
                d="M307.237248 42.521441A46.540625 46.540625 0 1 1 344.446708 127.87152C171.941755 203.160838 70.822134 384.331359 97.279635 570.74986c26.444701 186.418501 173.951348 332.286754 360.625848 356.606662 186.6617 24.319909 366.616225-78.873304 439.93435-252.287054a46.540625 46.540625 0 1 1 85.721279 36.262265c-89.599664 211.954405-309.541239 338.085132-537.687584 308.350843C217.727184 989.948288 37.42706 811.683356 5.119981 583.844211c-32.319879-227.839146 91.263658-449.278315 302.130067-541.309971zM512.02368 0a511.90848 511.90848 0 0 1 362.021042 149.989838A512.151679 512.151679 0 0 1 1023.99616 512.10048a46.553425 46.553425 0 0 1-46.540625 46.553425H512.02368a46.553425 46.553425 0 0 1-46.540626-46.553425V46.566225A46.553425 46.553425 0 0 1 512.02368 0z m46.540625 95.705241V465.534254h369.752214a419.032029 419.032029 0 0 0-120.10195-249.727063 418.852829 418.852829 0 0 0-249.650264-120.11475z"
                fill="#1290C9"
                p-id="8054"
              ></path>
            </svg>
            <svg
              t="1763780588104"
            class="icon icon-size"
              v-if="CompanySizeShow == 'Echarts'"
              @click="CompanySizeShow = 'Table'"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="7846" 
            >
              <path
                d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                fill="#1A2332"
                p-id="7847"
              ></path>
            </svg>
          </h2>
          <div
            class="flex_center_between_box margin-left10"
            style="margin-bottom: 0px"
          >
            <ul
              class="flex_center_bettwen"
              v-if="CompanySizeShow == 'Table'"
              style="width: 100%; height: 64px"
            >
              <li
                class="Database-Cared Database-Cared-Size"
                v-for="(item, index) in companySizeList"
                :key="index"
              >
                <p class="font26 font1290C9 font_bold">{{ item.cnt }}</p>
                <p class="font18 font1A2332 flex_center">
                  {{ item.groupNameEn }}
                </p>
              </li>
            </ul>
          </div>
          <div
            class="Products_lesft"
            v-show="CompanySizeShow == 'Echarts'"
            style="height: auto"
          >
            <div
              ref="SupplyChainEchart2"
              style="width: 98%; height: 100%; min-height: 25rem"
            ></div>
          </div>
        </div>
        <div
          class="accountright_cont_box margin-bottom10 margin-left10"
          v-if="CompanySizeShow == 'Table'"
          style="width: 29%"
        >
          <h2 class="history_box-head flex_center_between_box">{{ $t("DataManagement.CompanyDQI") }}</h2>
          <div class="flex_center_between_box" style="margin-bottom: 0px">
            <ul class="flex_center_bettwen" style="width: 100%; height: 64px">
              <li
                class="Database-Cared Database-Cared-Size"
                v-for="(item, index) in companyDQIList"
                :key="index"
              >
                <p class="font26 font1290C9 font_bold">{{ item.cnt }}</p>
                <p class="font18 font1A2332 flex_center">
                  {{ item.groupNameEn }}
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="accountright_cont_box margin-bottom10 margin-left10"
          v-if="CompanySizeShow == 'Table'"
          style="width: 29%"
        >
          <h2 class="history_box-head flex_center_between_box">
            {{ $t("DataManagement.CompanyStatus") }}
          </h2>
          <div class="flex_center_between_box" style="margin-bottom: 0px">
            <ul class="flex_center_bettwen" style="width: 100%; height: 64px">
              <li
                class="Database-Cared Database-Cared-Size"
                v-for="(item, index) in companyStatusList"
                :key="index"
              >
                <p class="font26 font1290C9 font_bold">{{ item.cnt }}</p>
                <p class="font18 font1A2332 flex_center">
                  {{ item.groupNameEn }}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="flex_center_bettwen">
        <!-- <div class="accountright_cont_box margin-bottom10" style="width: 25%;"
                    v-if="CreditAssessmentShow == 'Table'">
                    <h2 class="history_box-head flex_center_between_box">
                        Risk Scanning
                    </h2>
                    <div class="flex_center_between_box " style="margin-bottom: 0px;">

                        <ul class=" flex_center_bettwen" style="width: 100%;height: 87px;">
                            <li class="Database-Cared  Database-Cared-Size" v-for="(item, index) in riskScanningList"
                                :key="index">
                                <p class="font18  flex_center" :class="'color'+index">{{ item.groupNameEn }}</p>
                                <p class="font26  font_bold"  :class="'color'+index">{{ item.cnt }}</p>
                            </li>

                        </ul>

                    </div>
                </div> -->

        <div
          class="accountright_cont_box margin-bottom10"
          :style="
            CreditAssessmentShow == 'Table' ? 'width:100%;' : 'width:100%;'
          "
        >
          <h2 class="history_box-head flex_center_between_box">
            {{ $t("DataManagement.CreditAssessment") }}
            <svg
              t="1763711828255"
            class="icon icon-size"
              v-if="CreditAssessmentShow == 'Table'"
              @click="
                CreditAssessmentShow = 'Echarts';
                setEchartsAll();
              "
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="8053" 
            >
              <path
                d="M307.237248 42.521441A46.540625 46.540625 0 1 1 344.446708 127.87152C171.941755 203.160838 70.822134 384.331359 97.279635 570.74986c26.444701 186.418501 173.951348 332.286754 360.625848 356.606662 186.6617 24.319909 366.616225-78.873304 439.93435-252.287054a46.540625 46.540625 0 1 1 85.721279 36.262265c-89.599664 211.954405-309.541239 338.085132-537.687584 308.350843C217.727184 989.948288 37.42706 811.683356 5.119981 583.844211c-32.319879-227.839146 91.263658-449.278315 302.130067-541.309971zM512.02368 0a511.90848 511.90848 0 0 1 362.021042 149.989838A512.151679 512.151679 0 0 1 1023.99616 512.10048a46.553425 46.553425 0 0 1-46.540625 46.553425H512.02368a46.553425 46.553425 0 0 1-46.540626-46.553425V46.566225A46.553425 46.553425 0 0 1 512.02368 0z m46.540625 95.705241V465.534254h369.752214a419.032029 419.032029 0 0 0-120.10195-249.727063 418.852829 418.852829 0 0 0-249.650264-120.11475z"
                fill="#1290C9"
                p-id="8054"
              ></path>
            </svg>
            <svg
              t="1763780588104"
            class="icon icon-size"
              v-if="CreditAssessmentShow == 'Echarts'"
              @click="CreditAssessmentShow = 'Table'"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="7846" 
            >
              <path
                d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                fill="#1A2332"
                p-id="7847"
              ></path>
            </svg>
          </h2>
          <div
            class="Credit-Assessment-bg"
            v-if="CreditAssessmentShow == 'Table'"
          ></div>
          <div
            class="flex_center_between_box"
            style="margin-bottom: 0px"
            v-if="CreditAssessmentShow == 'Table'"
          >
            <ul class="flex_center_bettwen" style="width: 100%; height: 71px">
              <li
                v-for="(item, index) in creditAssessmentList"
                :key="index"
                class="Database-Cared Database-Cared-Size"
                style="justify-content: start"
              >
                <p class="line" style="background-color: #00d030"></p>
                <p
                  class="font18 flex_center"
                  :class="'colorAssessment' + index"
                >
                  {{ item.groupNameEn }}
                </p>
                <p class="font26 font_bold" :class="'colorAssessment' + index">
                  {{ item.cnt }}
                </p>
              </li>
            </ul>
          </div>
          <div
            class="Products_lesft"
            v-show="CreditAssessmentShow == 'Echarts'"
            style="height: auto"
          >
            <div
              ref="SupplyChainEchart3"
              style="width: 98%; height: 100%; min-height: 25rem"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import {
  getUserCompanyActionCountryMap,
  getUserCompanyActionSummary,
  getUserCompanyActionGroup,
} from "@/api/userApi";
export default {
  mixins: [mixins1],
  components: {},
  props: {
    isOpenSlct: {
      type: Boolean,
    },
  },
  watch: {},
  data() {
    return {
      QuarterList: [
        {
          label: "Q1",
          value: "01-01 00:00:00,03-31 23:59:59",
        },
        {
          label: "Q2",
          value: "04-01 00:00:00,06-30 23:59:59",
        },
        {
          label: "Q3",
          value: "07-01 00:00:00,09-30 23:59:59",
        },
        {
          label: "Q4",
          value: "10-01 00:00:00,12-31 23:59:59",
        },
      ],
      MonthList: [
        {
          label: "1",
          value: "01-01 00:00:00,01-31 23:59:59",
        },
        {
          label: "2",
          value: "02-01 00:00:00,02-30 23:59:59",
        },
        {
          label: "3",
          value: "03-01 00:00:00,03-31 23:59:59",
        },
        {
          label: "4",
          value: "04-01 00:00:00,04-30 23:59:59",
        },
        {
          label: "5",
          value: "05-01 00:00:00,05-31 23:59:59",
        },
        {
          label: "6",
          value: "06-01 00:00:00,06-30 23:59:59",
        },
        {
          label: "7",
          value: "07-01 00:00:00,07-31 23:59:59",
        },
        {
          label: "8",
          value: "08-01 00:00:00,08-31 23:59:59",
        },
        {
          label: "9",
          value: "09-01 00:00:00,09-30 23:59:59",
        },
        {
          label: "10",
          value: "10-01 00:00:00,10-31 23:59:59",
        },
        {
          label: "11",
          value: "11-01 00:00:00,11-30 23:59:59",
        },
        {
          label: "12",
          value: "12-01 00:00:00,12-31 23:59:59",
        },
      ],
      Quarter: "",
      CompanyTypeShow: "Table",
      YearsinBusinessShow: "Table",
      CompanySizeShow: "Table",
      CreditAssessmentShow: "Table",
      CountryShow: "Table",
      Month: "",
      reLoginVis: false,
      datePicker: [],
      addDialog: false,
      menuActive: 1,
      CategoryYear: null,
      companyDQIList: [],
      companySizeList: [],
      riskScanningList: [],
      companyStatusList: [],
      companyTypeList: [],
      creditAssessmentList: [],
      yearsInBusinessList: [],
      AllContrylist: [],
      window: window,
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      allDataObject: {
        allData: "",
        companiesViewed: "",
        companiesCollected: "",
        companiesUploaded: "",
        myPortfolio: "",
      },
      timer: [],
    };
  },
  beforeDestroy() {},
  destroyed() {},
  mounted() {
    this.$store.dispatch("app/setTools", {
      name: "select",
      key: "isActive",
      value: false,
    });
    this.getUserCompanyActionCountryMapList();
  },

  methods: {
    setEchartsAll() {
      let that = this;
      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);
      this.echartsBox1 = this.$echarts.init(this.$refs.SupplyChainEchart1);
      this.echartsBox2 = this.$echarts.init(this.$refs.SupplyChainEchart2);
      this.echartsBox3 = this.$echarts.init(this.$refs.SupplyChainEchart3);
      this.echartsBox4 = this.$echarts.init(this.$refs.SupplyChainEchart4);
      this.echartsBox5 = this.$echarts.init(this.$refs.SupplyChainEchart5);
      this.companyTypeList.map((item) => {
        item.name = item.groupName;
        item.value = item.cnt;
      });
      this.yearsInBusinessList.map((item) => {
        item.name = item.groupName;
        item.value = item.cnt;
      });
      this.companySizeList.map((item) => {
        item.name = item.groupName;
        item.value = item.cnt;
      });
      this.creditAssessmentList.map((item) => {
        item.name = item.groupName;
        item.value = item.cnt;
      });
      let mapdata = [];

      this.AllContrylist.map((item) => {
        item.name = item.groupNameEn;
        item.value = item.cnt;

        if (item.groupNameEn) {
          mapdata.push({
            name: item.groupNameEn,
            value: [item.latude, item.lotude],
            Num: item.cnt,
          });
        }
      });

      const option = {
        color: [
          "#00D030",
          "#FFF700",
          "#FFAD00",
          "#FF2900",
          "#FF4FD6 ",
          "#9851FF",
          "#642FC7",
        ],
        tooltip: {
          trigger: "item",
        },
        grid: {
          left: "1%", // 设置左侧边距
          right: "0%",
          top: "5%",
          bottom: "0%",
          containLabel: true,
        },
        legend: {
          orient: "vertical",
          top: "20%",
          left: "right",
        },
        series: [
          {
            name: "Company Type",
            type: "pie",
            radius: "50%",
            data: that.companyTypeList,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      const option1 = {
        color: [
          "#00D030",
          "#FFF700",
          "#FFAD00",
          "#FF2900",
          "#FF4FD6 ",
          "#9851FF",
          "#642FC7",
        ],
        tooltip: {
          trigger: "item",
        },
        grid: {
          left: "1%", // 设置左侧边距
          right: "0%",
          top: "5%",
          bottom: "0%",
          containLabel: true,
        },
        legend: {
          orient: "vertical",
          top: "20%",
          left: "right",
        },
        series: [
          {
            name: "Years in Business",
            type: "pie",
            radius: "50%",
            data: that.yearsInBusinessList,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      const option2 = {
        color: [
          "#00D030",
          "#FFF700",
          "#FFAD00",
          "#FF2900",
          "#FF4FD6 ",
          "#9851FF",
          "#642FC7",
        ],
        tooltip: {
          trigger: "item",
        },
        grid: {
          left: "1%", // 设置左侧边距
          right: "0%",
          top: "5%",
          bottom: "0%",
          containLabel: true,
        },
        legend: {
          orient: "vertical",
          top: "20%",
          left: "right",
        },
        series: [
          {
            name: "Company Size",
            type: "pie",
            radius: "50%",
            data: that.companySizeList,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      const option3 = {
        color: [
          "#00D030",
          "#FFF700",
          "#FFAD00",
          "#FF2900",
          "#FF4FD6 ",
          "#9851FF",
          "#642FC7",
        ],
        tooltip: {
          trigger: "item",
        },
        grid: {
          left: "1%", // 设置左侧边距
          right: "0%",
          top: "5%",
          bottom: "0%",
          containLabel: true,
        },
        legend: {
          orient: "vertical",
          top: "20%",
          left: "right",
        },
        series: [
          {
            name: "Credit Assessment",
            type: "pie",
            radius: "50%",
            data: that.creditAssessmentList,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      const option5 = {
        color: [
          "#00D030",
          "#FFF700",
          "#FFAD00",
          "#FF2900",
          "#FF4FD6 ",
          "#9851FF",
          "#642FC7",
        ],
        tooltip: {
          trigger: "item",
        },
        grid: {
          left: "1%", // 设置左侧边距
          right: "0%",
          top: "5%",
          bottom: "0%",
          containLabel: true,
        },
        legend: {
          orient: "vertical",
          top: "20%",
          left: "right",
        },
        series: [
          {
            name: "Country",
            type: "pie",
            radius: "50%",
            data: that.AllContrylist,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      let series = [
        {
          type: "effectScatter",
          coordinateSystem: "geo",
          zlevel: 2,
          rippleEffect: {
            period: 4,
            brushType: "fill",
            scale: 0,
          },
          label: {
            normal: {
              show: false,
              position: "top",
              offset: [5, 0], //偏移设置
              formatter: function (params) {
                // 只在点和飞线上显示 tooltip
                if (params.seriesType === "effectScatter") {
                  return params.data.name + " : " + params.data.Num;
                }
                // 其他情况返回空字符串，不显示 tooltip
                return "";
              },
              textStyle: {
                color: "#1A2332",
              },
            },
            emphasis: {
              show: false,
            },
          },

          symbol: "image://" + require("@/assets/images/AllCountryMapicon.png"),
          symbolSize: [19, 32],
          itemStyle: {
            normal: { show: false },
            color: "red",
          },
          data: mapdata,
        },
      ];
      //   const tooltipFormatter = (params) => {
      //     const items = coordinateDict[coordKey];
      //     // <div>Province:${item.province || 'N/A'}</div>
      //     const content = items.map(item => `
      //       <div style="margin-bottom: 12px;">
      //         <div>Company name: ${item.name}</div>
      //         <div>Relationship: ${item.relatedEn}</div>
      //           <div>Location: ${item.address } ${item.province }</div>

      //       </div>
      //     `).join('');

      //     return `
      //       <div  style="
      //         max-height: 200px;
      //         overflow-y: auto;
      //         padding: 12px;
      //         box-sizing: border-box;
      //         font-size: 14px;
      //         color: #1a2332;
      //         background: rgba(255,255,255,0.95);
      //         border-radius: 12px;
      //         border: 1px solid #1290C9;
      //         box-shadow: 0 4px 12px rgba(18, 144, 201, 0.2);

      //       ">
      //         ${content}
      //       </div>
      //     `;
      //   };
      const option4 = {
        visualMap: {
          min: 0,
          max: 10000,
          show: false,
          calculable: true,
          color: ["#ff9500"],
          textStyle: { color: "#fff" },
        },
        geo: {
          map: "world",
          aspectScale: 0.75, // 地图长宽比
          label: {
            emphasis: { show: false, color: "#fff" },
          },
          roam: false,
          zoom: 1.25, // 初始缩放级别
          layoutCenter: ["50%", "50%"],
          layoutSize: "180%",
          itemStyle: {
            normal: {
              areaColor: "#55ADD4",
              borderColor: "#9d9f9f",
            },
            emphasis: { areaColor: "#e7eaed" },
          },
        },
        tooltip: {
          trigger: "item",
          enterable: true,
          //   show:false,
          confine: true,
          backgroundColor: "transparent",
          borderWidth: 0,
          textStyle: {
            color: "#1A2332",
          },
          padding: 0,
          formatter: function (params) {
            // 只在点和飞线上显示 tooltip
            if (params.seriesType === "effectScatter") {
              return params.data.name + " : " + params.data.Num;
            }
            // 其他情况返回空字符串，不显示 tooltip
            return "";
          },
          position: function (point, params, dom, rect, size) {
            // point 是鼠标坐标 [x, y]
            // size是tooltip的大小 {contentSize: [width, height], viewSize: [width, height]}
            const x = point[0];
            const y = point[1];

            const viewWidth = size.viewSize[0];
            const viewHeight = size.viewSize[1];
            const boxWidth = size.contentSize[0];
            const boxHeight = size.contentSize[1];

            let posX = x + 5; // 默认 tooltip 右偏移 20px
            let posY = y - boxHeight / 2; // 垂直居中到鼠标

            // 防止溢出右侧视窗
            if (posX + boxWidth > viewWidth) {
              posX = x - boxWidth - 20;
            }
            // 防止溢出顶部视窗
            if (posY < 0) {
              posY = 0;
            }
            // 防止溢出底部视窗
            if (posY + boxHeight > viewHeight) {
              posY = viewHeight - boxHeight;
            }

            return [posX, posY];
          },
        },
        series: series,
      };

      this.echartsBox.setOption(option);
      this.echartsBox1.setOption(option1);
      this.echartsBox2.setOption(option2);
      this.echartsBox3.setOption(option3);
      this.echartsBox4.setOption(option4);
      this.echartsBox5.setOption(option5);
      this.$nextTick(() => {
        this.echartsBox.resize();
        this.echartsBox1.resize();
        this.echartsBox2.resize();
        this.echartsBox3.resize();
        this.echartsBox4.resize();
        this.echartsBox5.resize();
      });
    },
    ResetChange() {
      this.CategoryYear = "";
      this.Month = "";
      this.Quarter = "";
      this.datePicker = [];
      this.timer = [];
      this.getUserCompanyActionCountryMapList();
      this.setEchartsAll();
    },
    getUserCompanyActionCountryMapList() {
      let that = this;
      let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;
      getUserCompanyActionGroup({
        userId: userinfo.id,
        startTime: this.timer[0],
        endTime: this.timer[1],
      }).then((res) => {
        if (res.code == 200) {
          this.companyDQIList = res.data.companyDQIList;
          this.companySizeList = res.data.companySizeList;
          this.companyStatusList = res.data.companyStatusList;
          this.companyTypeList = res.data.companyTypeList;
          this.yearsInBusinessList = res.data.yearsInBusinessList;
          this.creditAssessmentList = res.data.creditAssessmentList;
          this.riskScanningList = res.data.riskScanningList;

          this.$nextTick(() => {
            that.setEchartsAll();
          });
        } else {
          this.companyDQIList = [];
          this.companySizeList = [];
          this.companyStatusList = [];
          this.companyTypeList = [];
          this.yearsInBusinessList = [];
          this.creditAssessmentList = [];
          this.riskScanningList = [];
        }
      });
      getUserCompanyActionSummary({
        userId: userinfo.id,
        startTime: this.timer[0],
        endTime: this.timer[1],
      }).then((res) => {
        if (res.code == 200) {
          this.allDataObject = res.data;
          this.$nextTick(() => {
            that.setEchartsAll();
          });
        } else {
          this.allDataObject = [];
        }
      });
      getUserCompanyActionCountryMap({
        userId: userinfo.id,
        startTime: this.timer[0],
        endTime: this.timer[1],
      }).then((res) => {
        if (res.code == 200) {
          this.AllContrylist = res.data;
          this.$nextTick(() => {
            that.setEchartsAll();
          });
        } else {
          this.AllContrylist = [];
        }
      });
    },
    onChangeParams(val, name) {
      if (name == "year") {
        this.Quarter = "";
        this.Month = "";
        this.datePicker = [];
        if (val == null) {
          this.CategoryYear = "";
          this.timer = [];
        } else {
          this.timer = [
            this.CategoryYear + "-01-01 00:00:00",
            this.CategoryYear + "-12-31 23:59:59",
          ];
        }
      }
      if (name == "Quarter") {
        if (val == "") {
          this.timer = [
            this.CategoryYear + "-01-01 00:00:00",
            this.CategoryYear + "-12-31 23:59:59",
          ];
        } else {
          this.Month = "";
          let valtime = val.split(",");
          this.timer = [
            this.CategoryYear + "-" + valtime[0],
            this.CategoryYear + "-" + valtime[1],
          ];
        }
      }
      if (name == "Month") {
        if (val == "") {
          this.timer = [
            this.CategoryYear + "-01-01 00:00:00",
            this.CategoryYear + "-12-31 23:59:59",
          ];
        } else {
          this.Quarter = "";
          let valtime = val.split(",");
          this.timer = [
            this.CategoryYear + "-" + valtime[0],
            this.CategoryYear + "-" + valtime[1],
          ];
        }
      }
      if (name == "datePicker") {
        this.CategoryYear = "";
        this.Month = "";
        this.Quarter = "";
        this.timer = this.datePicker;
      }
    },
  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.form-email {
  display: flex;
  width: 100%;
}

.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 1rem;
  color: #022955;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}

.item_txtcolor2 {
  color: #55b419;
}

.item_txtcolor3 {
  color: #ffa000;
}

.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}

.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}

.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}

.das_top_item .color4 {
  background: #ff7600;
}

.das_top_item .item_img img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: left;
}

.das_top_item .item_group {
  margin-left: 0.7142857142857143rem;
  font-size: 1.2857142857142858rem;

  /* width: 17.142857142857142rem; */
}

.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 0.35714285714285715rem;
}

.item_txt {
  font-size: 1.857142857143rem;
  text-align: center;
}

.cont_m {
  margin-top: 2.142857142857143rem;
  margin-bottom: 5.714285714285714rem;
}

.country_box {
  margin-top: 4.285714285714286rem;
}

.country_box .title {
  margin-bottom: 0;
}

.btn_blue {
  padding: 0.7142857142857143rem 1.4285714285714286rem;
  background: #1290c9;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 1.4285714285714286rem;
}

.btn_blue img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
  margin-right: 0.42857142857142855rem;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc;
border-radius: 10px;
  font-size: 18px;
  width: 310px;
}

.sel_box {
  width: fit-content !important;
}

.das_top_item {
  width: 32.5%;
  padding: 1.4285714285714286rem;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem
    rgba(0, 0, 0, 0.12);
}

.top_tab {
  margin-top: 2.857142857142857rem;
}

.jiange {
  color: #cccccc;
  margin: 0 1.4285714285714286rem;
  font-size: 1.285714285714286rem;
  /* font-size: 1.25em; */
}

.contclass {
  font-size: 1.285714285714286rem;
  color: #1290c9;
  font-style: normal;
}

/deep/ .el-table th.el-table__cell > .cell {
  font-family: "Arial Bold";
}

.last-colmun {
  padding: 2rem 0rem;
  border-bottom: 0.07142857142857142rem solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -2.142857142857143rem;
  right: 0rem;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 0.21428571428571427rem 0.21428571428571427rem;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 1.1428571428571428rem;
  margin-left: -0.35714285714285715rem;
  color: #1a2332;
  /* float: left; */
  line-height: 2.2857142857142856rem;
  position: relative;
  left: 47%;
}

@media screen and (max-width: 1441px) {
  .btn_blue {
    font-size: 14px;
    width: max-content;
  }
}

.Database-Cared {
  width: 19%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 12px;
  height: 116px;
  background-image: url("../../../../assets/images/jiugonggeBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* background-position: 50% 7.142857142857143rem; */
  pointer-events: auto;
}

.Database-Cared-Two {
  width: 16%;  
  background-image: none !important;
  border-radius: 10px;
  height: 106px;
  margin-bottom: 20px;
  border: 1px solid #8497ab;

   display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.Database-Cared-Size {
  width: fit-content;
  background-image: none !important;
  border-radius: 10px;
  height: 70px !important;
  justify-content: space-evenly;
}

.Database-Cared-Business {
  background-image: none !important;
  border-radius: 0px;
  width: 16.66666%;
  height: 56px !important;
}

.Database-Cared-Business-Bg {
  background-image: url("./../../../../assets//images//Yearinbusiness.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* background-position: 50% 7.142857142857143rem; */
  pointer-events: auto;
  height: 80px;
}

.Credit-Assessment-bg {
  height: 14px;
  background: linear-gradient(
    90deg,
    #00d030 0%,
    #00d030 11%,
    #fff700 33%,
    #ff9700 60%,
    #ff2900 77%,
    #ff2900 88%,
    #999999 100%
  );
  border-radius: 12px;
}

.line {
  width: 2px;
  height: 10px;
  border-radius: 0 0 2px 2px;
}

.Products_lesft {
  width: 100%;
}

/deep/ .el-input__inner {
  min-height: 40px;
}

.icon-size{
  height: 30px;
}
.accountright_cont_box{
  padding: 20px 30px ;
}
.Data_Management_box{ 
  width: 99.9%; 
    box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 12%);
    border-radius: 4px;
    background: #ffffff;
   padding: 20px 40px ;
}
.account_input .sel_box{
  height: auto;
}
@media screen and (max-width: 1920px) {
  .sel_box /deep/ .el-input__inner { 
    width: 232px;
    height: 32px;
    font-size: 14px !important;
    border-radius: 6px;
    
  min-height: 32px;
  }

  .el-range-editor.el-input__inner { 
    height: 32px;
    font-size: 14px !important;
    border-radius: 6px;
    
  min-height: 32px;
  }

  .btn_blue {
    padding: 9px 20px; 
  font-size: 14px;    
   border-radius: 6px;
line-height:14px ;
}


.Database-Cared {
  width: 19%; 
  border-radius: 10px;
  height: 87px; 
}

.Database-Cared-Two {  
  border-radius: 8px;
  height: 80px; 
}

.Database-Cared-Size { 
  border-radius: 8px; 
  margin-bottom: 15px;
  height: 52px !important; 
}

.Database-Cared-Business { 
  border-radius: 5px; 
  height: 42px !important;
}
.history_box-head{ 
    font-size: 20px;
    margin-bottom:15px;
}
.icon-size{
  height: 22px;
}
.Database-Cared-Business-Bg { 
  height: 60px;
}
.accountright_cont_box{
  padding: 15px 22px ;
}
.Data_Management_box{ 
   padding: 15px 30px ;
}
}
@media screen and (max-width: 1439px) {
  .sel_box /deep/ .el-input__inner { 
        width: 208px; 
       height: 27px;
    font-size: 12px !important;
    border-radius: 5px; 
  min-height: 27px;
  }

  .el-range-editor.el-input__inner { 
       height: 27px;
    font-size: 12px !important;
    border-radius: 5px;
  min-height: 27px;
  }
    .btn_blue {
    padding: 9px 20px; 
  font-size: 12px;    
   border-radius: 5px;
  line-height:14px ;

  }

  .Database-Cared { 
    border-radius: 8px;
    height: 78px; 
  }

.Database-Cared-Two {  
  border-radius: 6px;
  height: 70px; 
}

.Database-Cared-Size { 
  border-radius: 6px;
  height: 46px !important; 
}

.Database-Cared-Business { 
  border-radius: 6px; 
  height: 38px !important;
}
.history_box-head{ 
    font-size: 18px;
    margin-bottom:13px;
}
.icon-size{
  height: 20px;
}
.Database-Cared-Business-Bg { 
  height: 54px;
}
.accountright_cont_box{
  padding: 13px 20px ;
}
.Data_Management_box{ 
   padding: 13px 26px ;
}
}
</style>
